export const CustomChartDragTypes = {
    CHART: 'chart',
    FOLDER: 'folder',
    DATA_SOURCE_COLUMN: 'dataSourceColumn'
}